import { render, staticRenderFns } from "./MarketplaceResolveRequestForm.vue?vue&type=template&id=c121145e&scoped=true&"
import script from "./MarketplaceResolveRequestForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceResolveRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c121145e",
  null
  
)

export default component.exports